const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';
const SCROLL_SLIDE_IN_CLASSNAME = 'scroll-slide-in'
const HERO_ANIMATION_VIDEO_CONTAINER_CLASSNAME = 'hero-animation-video-container'
const HORIZONTAL_CAROUSEL_ITEM_CONTAINER = 'horizontal_carousel_item_container'
const SECURITY_ITEM_CONTAINER = 'security_item_container'
const LOTTIE_FRAME_RESTART_CONTAINER = 'lottie-frame--restart'

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

// text slide-in animation
function initializeSlideInAnimation() {
  const textBlocks = Array.from(document.getElementsByClassName(SCROLL_SLIDE_IN_CLASSNAME));
  if (textBlocks.length === 0) {
    return;
  }
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target); // stop observing after first reveal
      }
    });
  }, {
    threshold: 0.8,
    rootMargin: '0px 0px -10% 0px'
  });

  textBlocks.forEach(block => observer.observe(block));
}

// hero video behaviour
function initializeHeroVideoAnimationBehaviour() {
  const videoSections = Array.from(document.getElementsByClassName(HERO_ANIMATION_VIDEO_CONTAINER_CLASSNAME));
  if (videoSections.length === 0) return;

  const videoSection = videoSections[0];

  const handleEnded = (video) => {
    video.dataset.hasPlayed = "true"
  };

  // Select all videos inside this section
  const videos = videoSection.querySelectorAll('video');
  videos.forEach(video => video.removeEventListener('ended', () => handleEnded(video)))
  videos.forEach(video => video.addEventListener('ended', () => handleEnded(video)))

  const getVisibleVideo = () => {
    // window.getComputedStyle() checks CSS display: none properly
    return Array.from(videos).find(video => {
      const style = window.getComputedStyle(video);
      return style.display !== 'none' && style.visibility !== 'hidden' && video.offsetParent !== null;
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          const visibleVideo = getVisibleVideo();
          // Play only the visible video
          if (visibleVideo) {
            const hasPlayed = visibleVideo.dataset.hasPlayed === "true";
            if (visibleVideo.paused && !hasPlayed) {
              visibleVideo.play().catch(() => {});
            }
          }
          // videos.forEach(video => {
          //   const hasPlayed = video.dataset.hasPlayed === "true";
          //   if (video.offsetParent !== null && video.paused && !hasPlayed) { // offsetParent != null means visible
          //     video.play().then(() => window.hasHeroVideoPlayed = true).catch(() => {});
          //   }
          // });
        } else {
          // Pause all videos
          videos.forEach(video => {
            if (!video.paused) {
              video.pause();
            }
          });
        }
      });
    },
    {
      threshold: [0, 0.6, 1.0]
    }
  );

  observer.observe(videoSection);
}

// 
function initializeHorizontalCarouselAnimationBehaviour() {
  const slides = Array.from(document.getElementsByClassName(HORIZONTAL_CAROUSEL_ITEM_CONTAINER));

  if (slides.length == 0) {
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      const text = entry.target.querySelector('.text_container');
      if (entry.isIntersecting) {
        text.classList.add('visible');
        obs.unobserve(entry.target);
      }
      
    });
  }, { threshold: 0.6 }); // trigger when 60% visible

  slides.forEach(slide => observer.observe(slide));
}

function initializeSecurityTextAnimationBehaviour() {
  const securityItem = document.querySelector(`.${SECURITY_ITEM_CONTAINER}`);

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      const textContainer = entry.target.querySelector('.security_item_container__text-container');
      if (entry.isIntersecting) {
        textContainer.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });

  observer.observe(securityItem);
}

function initializeLottieFrameRestartBehaviour() {
  const frames = document.querySelectorAll(`.${LOTTIE_FRAME_RESTART_CONTAINER}`);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const lottiePlayer = entry.target.querySelector('lottie-player');
      if (entry.isIntersecting) {
        // Find the <lottie-player> or <canvas> inside the frame
        entry.target.classList.add('visible')

        // Restart animation
        if (lottiePlayer) {
          lottiePlayer.stop();
          lottiePlayer.play();
        }
      } else {
        entry.target.classList.remove('visible');
        lottiePlayer.stop();
      }
    });
  }, {
    threshold: 0.6 // Adjust visibility trigger (60% in view)
  });

  frames.forEach(frame => observer.observe(frame));
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
  initializeSlideInAnimation();
  initializeHeroVideoAnimationBehaviour();
  initializeHorizontalCarouselAnimationBehaviour();
  initializeSecurityTextAnimationBehaviour();
  initializeLottieFrameRestartBehaviour();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
